// Card Quick Add - Add variant to cart without page refresh
class CardQuickAdd {
  constructor() {
    this.init();
  }

  init() {
    // Attach click event to all quick add buttons
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.card-quick-add-btn');
      if (!button || button.classList.contains('disabled')) return;

      event.preventDefault();
      event.stopPropagation();
      
      // Check screen size
      if (window.innerWidth <= 768) {
        // Mobile: Select variant instead of adding to cart
        this.selectVariant(button);
      } else {
        // Desktop: Add to cart directly
        this.addToCart(button);
      }
    });

    // Add event listener for mobile add to cart button
    document.addEventListener('click', (event) => {
      const addButton = event.target.closest('.mobile_quick_add_add_to_cart');
      if (!addButton) return;

      event.preventDefault();
      event.stopPropagation();
      
      this.addSelectedVariantToCart();
    });
  }

  selectVariant(button) {
    // Remove selected class from all variant buttons in the mobile quick add
    const mobileQuickAdd = document.querySelector('.mobile_quick_add');
    if (mobileQuickAdd) {
      const allButtons = mobileQuickAdd.querySelectorAll('.card-quick-add-btn');
      allButtons.forEach(btn => btn.classList.remove('selected'));
    }
    
    // Add selected class to clicked button
    button.classList.add('selected');
    
    // Get delivery date from button and render it inside variant-info
    const deliveryDate = button.dataset.deliveryDate;
    const variantInfo = document.querySelector('.variant-info');
    
    if (variantInfo && deliveryDate) {
      variantInfo.textContent = deliveryDate;
      variantInfo.style.display = 'block';
    } else if (variantInfo) {
      variantInfo.textContent = '';
      variantInfo.style.display = 'none';
    }
  }

  addSelectedVariantToCart() {
    // Find the selected variant button
    const mobileQuickAdd = document.querySelector('.mobile_quick_add');
    if (!mobileQuickAdd) return;

    const selectedButton = mobileQuickAdd.querySelector('.card-quick-add-btn.selected');
    if (!selectedButton) {
      alert('Please select a variant first');
      return;
    }

    // Add to cart using the selected button
    this.addToCart(selectedButton);
  }

  addToCart(button) {
    const variantId = button.dataset.id;
    
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Add loading state
    button.classList.add('loading');
    button.disabled = true;

    // Get cart drawer element
    const cartDrawer = document.querySelector('cart-drawer');
    
    // Prepare form data
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    
    if (cartDrawer) {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    // Configure fetch
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    // Add to cart
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // Handle error
          console.error('Error adding to cart:', response.description);
          
          // Show error message (optional - could add a notification)
          if (response.description) {
            alert(response.description);
          }
          
          return;
        }
        document.querySelector('.mobile_quick_add').classList.remove('active');
        document.querySelector('.mobile-quick-add-layer').classList.remove('active');
        // Success - update cart and open drawer
        if (cartDrawer) {
          // Remove is-empty class from cart drawer and cart drawer items
          cartDrawer.classList.remove('is-empty');
          const cartDrawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawerItems) {
            cartDrawerItems.classList.remove('is-empty');
          }
          
          // Publish cart update event
          publish(PUB_SUB_EVENTS.cartUpdate, { 
            source: 'card-quick-add', 
            productVariantId: variantId, 
            cartData: response 
          });
          
          // Render cart contents and open drawer
          cartDrawer.renderContents(response);
          
          // Ensure product recommendations and slideshow are properly initialized after render
          setTimeout(() => {
            const productRecs = document.querySelector('cart-drawer product-recommendations');
            if (productRecs) {
              // Trigger a scroll event to ensure IntersectionObserver fires
              const cartDrawerItems = document.querySelector('cart-drawer-items');
              if (cartDrawerItems) {
                cartDrawerItems.scrollTop = cartDrawerItems.scrollTop;
              }
              
              // Ensure slideshow component is properly initialized
              const slideshowComponent = productRecs.querySelector('slideshow-component');
              if (slideshowComponent) {
                // Trigger a resize event to ensure slider calculates dimensions
                window.dispatchEvent(new Event('resize'));
                
                // Reset slider position to first slide
                const slider = slideshowComponent.querySelector('.complementary-slider');
                if (slider) {
                  slider.scrollLeft = 0;
                }
              }
            }
          }, 150);
        } else {
          // Fallback - redirect to cart page
          window.location = window.routes.cart_url;
        }
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        alert('There was an error adding the item to your cart. Please try again.');
      })
      .finally(() => {
        // Remove loading state
        button.classList.remove('loading');
        button.disabled = false;
        
        // Ensure is-empty class is removed (safety check)
        if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }
      });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CardQuickAdd();
  });
} else {
  new CardQuickAdd();
}

// Use event delegation for quick-add-open buttons to work with dynamically rendered content
document.addEventListener('click', (event) => {
  const button = event.target.closest('.quick-add-open');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();
  
  // Check if button has directly-add-to-cart class
  if (button.classList.contains('directly-add-to-cart')) {
    // Add product directly to cart without opening modal
    const variantId = button.dataset.id;
    
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Set the data-id on the button so addToCart can use it
    button.dataset.id = variantId;
    
    // Use CardQuickAdd instance to add to cart
    const cardQuickAdd = new CardQuickAdd();
    cardQuickAdd.addToCart(button);
    return;
  }
  
  button.classList.toggle('active');
  document.querySelector('.mobile-quick-add-header .variant-info').textContent = '';
  const mobileQuickAdd = document.querySelector('.mobile_quick_add');
  const mobileQuickAddLayer = document.querySelector('.mobile-quick-add-layer');

  if (!mobileQuickAdd || !mobileQuickAddLayer) return;

  if (window.innerWidth > 768) {
    // Desktop behavior
    const cardQuickAddContainer = button.closest('.product-card-wrapper').querySelector('.card-quick-add-container');
    if (cardQuickAddContainer) {
      cardQuickAddContainer.classList.toggle('active');
      button.classList.toggle('active');
    }
  } else {
    // Mobile behavior
    const cardQuickAddContainer = button.closest('.product-card-wrapper').querySelector('.card-quick-add-inner');
    if (cardQuickAddContainer) {
      const clonedContainer = cardQuickAddContainer.cloneNode(true);
      mobileQuickAdd.classList.add('active');
      mobileQuickAddLayer.classList.add('active');
      mobileQuickAdd.querySelector('.mobile_quick_add_sizes').innerHTML = clonedContainer.innerHTML;
    }
  }
});

// Use event delegation for mobile quick add layer close
document.addEventListener('click', (event) => {
  const mobileQuickAddLayer = event.target.closest('.mobile-quick-add-layer');
  if (!mobileQuickAddLayer) return;
  document.querySelectorAll('.quick-add-open').forEach(btn => btn.classList.remove('active'));
  const mobileQuickAdd = document.querySelector('.mobile_quick_add');
  if (mobileQuickAdd) {
    mobileQuickAdd.classList.remove('active');
    mobileQuickAddLayer.classList.remove('active');
  }
});

document.querySelector('.mobile_quick_add_close-part').addEventListener('click', () => {
  const mobileQuickAddLayer = document.querySelector('.mobile-quick-add-layer');
  const mobileQuickAdd = document.querySelector('.mobile_quick_add');
  if (mobileQuickAdd) {
    mobileQuickAdd.classList.remove('active');
    mobileQuickAddLayer.classList.remove('active');
  }
});



